import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import sad from "../Assets/images/experience/sad.png";
import happy from "../Assets/images/experience/happy.png";
import { useNavigate, useParams } from "react-router-dom";
import { EXLDownloadIcon, LeftArrow, PDFDownloadIcon, PrivateIcon, PublicIcon } from "../Assets/iconshere";
import vhappy from "../Assets/images/experience/veryhappy.png";
import Skeleton from "react-loading-skeleton";
import { exportMultipleChartsToPdf } from "../utils/pdf";
import { humanReadable } from "../utils/useWindowDimensions";
import { useLocation } from "react-router-dom";
import apiClient from "../apiClient";

const EventDetails = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [duration, setDuration] = useState(null);
  const [environment, setEnvironment] = useState(null);
  const [feedbacks, setFeedbacks] = useState([]);
  const [joined, setJoined] = useState(0);
  const [avgTime, setAvgTime] = useState(0);
  const [invited, setInvited] = useState(0);
  const [eventStartTime, setEventStartTime] = useState("");
  const [eventEndTime, setEventEndTime] = useState("");
  const [actualDuration, setActualDuration] = useState(0);
  const getEvent = async () => {
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/event/details/${id}`);

      // const { data } = await axios.get(`${configData.config.API_URL}/api/event/details/${id}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      let event = data;

      let formattedDuration = "";
      await getEventAnalytics(event.uuid);
      await getEnvironmentsList(event.environmentId);

      const startTime = moment(event.startTime).format("DD MMM, hh:mm A");
      const endTime = moment(event.endTime).format("DD MMM, hh:mm A");

      setEventStartTime(startTime);
      setEventEndTime(endTime);

      setDuration(humanReadable(moment(event.endTime).diff(moment(event.startTime), "seconds")));
      // //Duration Setting
      // const durationMinutes = Math.floor(
      //   (startTime - endTime) / (1000 * 60)
      // );
      // const hours = Math.floor(durationMinutes / 60);
      // const minutes = durationMinutes % 60;
      // hours > 0 ? (formattedDuration += `${hours}h `) : (formattedDuration += `${minutes}min`);

      setEvent(event);
      // setDuration(formattedDuration);
    } catch (error) {
      console.error("Error fetching event:", error);
    }
  };

  const getEnvironmentsList = async (environmentId) => {
    try {

      const data = await apiClient.get(`${configData.config.UNO_URL}/api/resource/environment/details/${environmentId}`);

      // const { data } = await axios.get(
      //   `${configData.config.UNO_URL}/api/resource/environment/details/${environmentId}`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${userData.token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      if (data) {
        setEnvironment(data);
      } else {
        console.error("Invalid environment data received from API.");
      }
    } catch (error) {
      console.error("Error fetching environments:", error);
    }
  };

  const getEventAnalytics = async (id) => {
    try {

      const data = await apiClient.get(`${configData.config.API_URL}/api/event/all/feedback/${id}`);

      // const { data } = await axios.get(`${configData.config.API_URL}/api/event/all/feedback/${id}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //     "Content-Type": "application/json",
      //   },
      // });

      setJoined(data.userJoined);
      setInvited(data.details.length);
      setAvgTime(data.avgTime);
      setFeedbacks(data.details);
      setActualDuration(data.actualTime);
      // if (data.ongoing) {
      //   setTimeout(() => {
      //     getEventAnalytics(id)
      //   }, [1000])
      // }
    } catch (error) {
      console.error("Error fetching environments:", error);
    }
  };

  const tableData = [
    ["Event Name", event?.name || "-"],
    ["Environment", environment?.name || "-"],
    ["Event Type", event?.type || "-"],
    ["Total session duration", duration || "-"],
    ["Actual session duration", humanReadable(actualDuration)],
    ["Avg. Session/user", humanReadable(avgTime)],
    ["Total Feedbacks Received", joined],
    ["Participant", invited],
    ["Joined", joined || 0],
    ["Absentees", invited - joined],
    ["Report Generated at", moment().format("ll")],
  ];
  const tableData1 = [["Name", "Average Time", "Experience", "Comments"]];

  feedbacks.forEach((feedback, index) => {
    const rowData = [
      `${feedback.name}\n${feedback.email}`,
      humanReadable(feedback.timeSpent),
      feedback.rating <= 1 ? "Sad" : feedback.rating <= 3 ? "Happy" : feedback.rating <= 5 ? "Very Happy" : "",
      feedback.feedback,
    ];
    tableData1.push(rowData);
  });

  useEffect(() => {
    getEvent();
  }, [id]);

  return (
    <>
      <div className="container-fluid admindashboard p-4 pt-2 bg-grey-main">
        <div className="row px-2">
          <div className="col-md-6 d-flex align-items-end">
            <button onClick={() => navigate("/events")} className="backbtn cursor-pointer ps-2 mb-2" title="Back">
              <LeftArrow />
              Back
            </button>
          </div>
          <div className="col-md-6 d-flex justify-content-end gap-2 p-0 align-items-center">
            <button
              className="DefaultRedBtn download"
              title="Download PDF"
              onClick={() => exportMultipleChartsToPdf("Event_Detail", tableData, tableData1)}
            >
              <PDFDownloadIcon />
            </button>
          </div>
        </div>
        {event !== null && environment !== null ? (
          <div className="row pt-2 event-detail-page">
            <div className="col-md-5 targetdashname">
              <div className="groupcardesign">
                <div className="name-env">
                  <Tooltip title={event.name} placement="top" arrow>
                    <span className="text-dark">{event.name}</span>
                  </Tooltip>
                  <span>
                    {" "}
                    {eventStartTime} - {eventEndTime}{" "}
                  </span>
                  <span className="org-user-name">
                    {userData.user?.avatar ? (
                      <img
                        src={userData.user.avatar}
                        alt={userData.user.name
                          .split(" ")
                          .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                          .join("")}
                      />
                    ) : (
                      <span className="user-ini">
                        {" "}
                        {userData.user.name
                          .split(" ")
                          .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                          .join("")}{" "}
                      </span>
                    )}
                    {userData.user.name}
                  </span>
                </div>
                <span className="envi-name">
                  <p>{environment.name}</p>
                  <span>
                    {event.type == "PRIVATE" ? <PrivateIcon /> : <PublicIcon />}

                    {event.type}
                  </span>
                </span>
              </div>
            </div>
            <div className="col-md-7">
              <div className="row targetdashname">
                <div className="col-md-3">
                  <div className="cardbodyitems ">
                    <div className="dattacardd">
                      <div className="card-header">
                        <div className="infodetail date date-counter">
                          <p className="text-sm text-capitalize">Total session duration</p>
                          <h4 className="text-dark">{duration}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="cardbodyitems ">
                    <div className="dattacardd">
                      <div className="card-header">
                        <div className="infodetail date date-counter">
                          <p className="text-sm text-capitalize">Average Session Time</p>
                          <h4 className="text-dark">{humanReadable(avgTime)}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="cardbodyitems ">
                    <div className="dattacardd">
                      <div className="card-header">
                        <div className="infodetail date date-counter">
                          <p className="text-sm text-capitalize">Actual Event Duration</p>
                          <h4 className="text-dark">{humanReadable(actualDuration)}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="cardbodyitems ">
                    <div className="dattacardd">
                      <div className="card-header">
                        <div className="infodetail date date-counter">
                          <p className="text-sm text-capitalize">Total Feedbacks Received</p>
                          <h4 className="text-dark">{joined}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <div className="event-points p-3" style={{ backgroundColor: "#fff" }}>
                <span className="event-peaks">Participants : {invited}</span>
                <span className="event-peaks">Joined : {joined}</span>
                <span className="event-peaks">Absentees : {invited - joined}</span>
              </div>
              <div className="event-users-table">
                <div className="table-responsive workflowtb stickyhead">
                  <table className="table align-middle table-nowrap mb-0 p-4">
                    <thead>
                      <tr>
                        <th className="text-start">Name</th>
                        <th className="center">Attendance</th>
                        <th style={{ textAlign: "center" }}>Time Spent</th>
                        <th style={{ textAlign: "center" }}>Experience</th>
                        <th style={{ textAlign: "left" }}>Comments</th>
                      </tr>
                    </thead>
                    <tbody>
                      {feedbacks &&
                        feedbacks.map((feedback, index) => {
                          return (
                            <tr key={index + 1}>
                              <td>
                                <div className="d-flex gap-2 align-items-center justify-content-start namewithmail">
                                  {feedback.avatar ? (
                                    <img src={feedback.avatar} alt="" referrerPolicy={"no-referrer"} />
                                  ) : (
                                    <span className="ranked-ini">
                                      {feedback.name
                                        .split(" ")
                                        .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                        .join("")}
                                    </span>
                                  )}
                                  <div>
                                    <p>{feedback.name}</p>
                                    <p>{feedback.email}</p>
                                  </div>
                                </div>
                              </td>
                              <td>{feedback.attendance}</td>
                              <td>{feedback.timeSpent === 0 ? "NA" : humanReadable(feedback.timeSpent)}</td>
                              <td>
                                <Tooltip
                                  title={
                                    feedback.rating <= 1
                                      ? "Sad"
                                      : feedback.rating <= 3
                                        ? "Happy"
                                        : feedback.rating <= 5
                                          ? "Very Happy"
                                          : ""
                                  }
                                >
                                  <img
                                    src={
                                      feedback.rating <= 1
                                        ? sad
                                        : feedback.rating <= 3
                                          ? happy
                                          : feedback.rating <= 5
                                            ? vhappy
                                            : ""
                                    }
                                    style={{ width: "25px" }}
                                    alt=""
                                    referrerPolicy={"no-referrer"}
                                  />
                                </Tooltip>
                              </td>
                              <td style={{ textAlign: "left" }}>{feedback.feedback}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="row pt-2 event-detail-page">
              <div className="col-md-5 targetdashname">
                <div className="groupcardesign">
                  <div className=" p-0 m-0">
                    <Skeleton width="10vw" />
                    <Skeleton width="10vw" />
                    <Skeleton width="5vw" />
                  </div>

                  <span className=" p-2 m-0">
                    <Skeleton width="5vw" baseColor="#fff" highlightColor="#ca373c50" />
                    <Skeleton width="5vw" />
                  </span>
                </div>
              </div>
              <div className="col-md-7">
                <div className="row targetdashname">
                  <div className="col-md-4">
                    <div className="cardbodyitems ">
                      <div className="dattacardd">
                        <div className="card-header">
                          <div className="infodetail date date-counter">
                            <p className="text-sm text-capitalize">
                              {" "}
                              <Skeleton width="5vw" />
                            </p>
                            <h4 className="text-dark">
                              {" "}
                              <Skeleton width="5vw" />
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="cardbodyitems ">
                      <div className="dattacardd">
                        <div className="card-header">
                          <div className="infodetail date date-counter">
                            <p className="text-sm text-capitalize">
                              {" "}
                              <Skeleton width="5vw" />
                            </p>
                            <h4 className="text-dark">
                              {" "}
                              <Skeleton width="5vw" />
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="cardbodyitems ">
                      <div className="dattacardd">
                        <div className="card-header">
                          <div className="infodetail date date-counter">
                            <p className="text-sm text-capitalize">
                              {" "}
                              <Skeleton width="5vw" />
                            </p>
                            <h4 className="text-dark">
                              {" "}
                              <Skeleton width="5vw" />
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="event-points p-3" style={{ backgroundColor: "#fff" }}>
                  <div className="d-flex align-item-center justify-content-start gap-3">
                    <Skeleton width="10vw" height="40px" />
                    <Skeleton width="10vw" height="40px" />
                    <Skeleton width="10vw" height="40px" />
                  </div>
                </div>
                <div className="event-users-table">
                  <div className="table-responsive workflowtb stickyhead">
                    <table className="table align-middle table-nowrap mb-0 p-4">
                      <thead>
                        <tr>
                          <th className="text-start">Name</th>
                          <th style={{ textAlign: "center" }}> Attendance </th>
                          <th style={{ textAlign: "center" }}>Time Spent</th>
                          <th style={{ textAlign: "left" }}>Experience</th>
                          <th style={{ textAlign: "left" }}>Comments</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <div className="d-flex gap-2 align-items-center justify-content-start namewithmail">
                              <Skeleton count={1} circle height="50px" width="50px" />
                              <div>
                                <p>
                                  <Skeleton width="12vw" />
                                </p>
                                <p>
                                  <Skeleton width="8vw" />
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <Skeleton width="8vw" />
                          </td>
                          <td>
                            <Skeleton width="8vw" />
                          </td>
                          <td>
                            <Skeleton width="5vw" />
                          </td>
                          <td style={{ textAlign: "left" }}>
                            <Skeleton width="20vw" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default EventDetails;
